/** @jsxImportSource @emotion/react */

import colors from '@sportninja/common/constants/appColors'

interface PreviewIconProps {
  size?: number
  color?: string
}

const PreviewIcon = ({
  size = 16,
  color = colors.PRIMARY,
}: PreviewIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size + 1}
      viewBox='0 0 16 17'
      fill='none'
    >
      <path
        d='M12.6667 2.5H3.33333C2.59333 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.59333 14.5 3.33333 14.5H12.6667C13.4 14.5 14 13.9 14 13.1667V3.83333C14 3.1 13.4067 2.5 12.6667 2.5ZM12.6667 13.1667H3.33333V5.16667H12.6667V13.1667ZM8 7.5C9.22667 7.5 10.32 8.14 10.8933 9.16667C10.32 10.1933 9.22667 10.8333 8 10.8333C6.77333 10.8333 5.68 10.1933 5.10667 9.16667C5.68 8.14 6.77333 7.5 8 7.5ZM8 6.5C6.18 6.5 4.62667 7.60667 4 9.16667C4.62667 10.7267 6.18 11.8333 8 11.8333C9.82 11.8333 11.3733 10.7267 12 9.16667C11.3733 7.60667 9.82 6.5 8 6.5ZM8 10.1667C7.44667 10.1667 7 9.72 7 9.16667C7 8.61333 7.44667 8.16667 8 8.16667C8.55333 8.16667 9 8.61333 9 9.16667C9 9.72 8.55333 10.1667 8 10.1667Z'
        fill={color}
      />
    </svg>
  )
}

export default PreviewIcon
